<template>
  <div class="ti-email-confirmation">
    <div class="ti-email-confirmation__content">
      <div
        class="ti-email-confirmation__text"
        v-if="valuation === '' || valuation === null"
      >
        <div class="ti-email-confirmation__icon" ref="iconOldCarBlue"></div>

        <h3>{{ $t('i18n.residualValueError.textImage.headline') }}</h3>

        <p>{{ $t('i18n.residualValueError.textImage.copy') }}</p>
      </div>

      <div
        class="ti-email-confirmation__text"
        v-if="valuation && valuation.length > 0"
      >
        <div class="ti-email-confirmation__icon" ref="iconMoneyBlue"></div>

        <h3>
          {{
            $t('i18n.basicContactConfirmation.residualValue.feedback.headline')
          }}
        </h3>

        <p>{{ $t('i18n.basicContactConfirmation.residualValue.copy') }}</p>

        <div
          class="ti-email-confirmation__price"
          :class="{
            'ti-email-confirmation__price--large': valuation?.length < 14,
          }"
        >
          <span>{{ valuation }}</span>

          <ModalComponent
            class="ti-email-confirmation__tooltip"
            :modal="$t('i18n.basicContactConfirmation.residualValue.modal')"
            :theme="ModalTheme.Default"
          />
        </div>
      </div>

      <div
        class="ti-email-confirmation__termin-content"
        v-if="valuation && valuation.length > 0"
      >
        <h4>
          {{ $t('i18n.basicContactConfirmation.residualValue.ctaHeadline') }}
        </h4>

        <p>{{ $t('i18n.basicContactConfirmation.residualValue.ctaNoteMe') }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { ModalTheme } from '../../utils/interfaces';
import ModalComponent from '../modal/modal.vue';
import setup from '../../composables/setup';
import lottie from 'lottie-web';

interface Props {
  valuation?: String;
}

const iconOldCarBlue = ref<Element | null>(null);
const iconContactBlue = ref<Element | null>(null);
const iconMoneyBlue = ref<Element | null>(null);

const { $parseSrc } = setup();
const props = defineProps<Props>();

onMounted(() => {
  lottie.loadAnimation({
    container: iconOldCarBlue.value as Element,
    renderer: 'svg',
    autoplay: true,
    loop: true,
    path: $parseSrc(`/assets/icons/icon_conf_oldcar_blue.json`),
  });

  lottie.loadAnimation({
    container: iconContactBlue.value as Element,
    renderer: 'svg',
    autoplay: true,
    loop: true,
    path: $parseSrc(`/assets/icons/icon_conf_contact_blue.json`),
  });

  lottie.loadAnimation({
    container: iconMoneyBlue.value as Element,
    renderer: 'svg',
    autoplay: true,
    loop: true,
    path: $parseSrc(`/assets/icons/icon_conf_money_blue.json`),
  });
});
</script>

<style lang="scss" src="./email-confirmation.scss"></style>
